import allChartDataHandle from "./index"
import { getSwData, getDocumentCookie } from "utils"
const defaultColor = [
  "rgb(0, 71, 255)",
  "rgb(0, 228, 228)",
  "rgb(255, 166, 63)",
  "rgb(214, 39, 176)",
  "rgb(192, 53, 227)",
  "rgb(128, 44, 245)",
  "rgb(139, 255, 74)",
  "rgb(255, 164, 41)",
  "rgb(255, 92, 90)",
  "rgb(255, 88, 199)",
  "rgb(83, 255, 172)",
  "rgb(255, 249, 31)",
  "rgb(65, 255, 209)",
  "rgb(109, 92, 255)",
  "rgb(0, 137, 255)",
  "rgb(255, 105, 105)",
  "rgb(131, 255, 125)",
  "rgb(78, 219, 255)",
  "rgb(227, 255, 89)",
  "rgb(183, 0, 255)"
]
const defaultGradientColor = [
  ["rgba(51, 120, 255, 1)", "rgba(148, 66, 254, 1)"],
  ["rgba(100, 251, 215, 1)", "rgba(83, 131, 255, 1)"],
  ["rgba(254, 126, 7, 1)", "rgba(255, 222, 103, 1)"],
  ["rgba(193, 92, 255, 1)", "rgba(255, 84, 84, 1)"],
  ["rgba(84, 249, 189, 1)", "rgba(143, 242, 118, 1)"],
  ["rgba(139, 36, 255, 1)", "rgba(239, 58, 255, 1)"],
  ["rgba(100, 181, 255, 1)", "rgba(130, 251, 234, 1)"],
  ["rgba(255, 151, 67, 1)", "rgba(255, 218, 107, 1)"],
  ["rgba(0, 172, 209, 1)", "rgba(109, 229, 255, 1)"],
  ["rgba(203, 4, 183, 1)", "rgba(246, 106, 233, 1)"]
]
export default {
  methods: {
    async updateData(name) {
      if (!this.options.appId) return
      const url = `engine2/data/api-v2/chart/${this.options.appId}/data`
      const { pageId, websiteId } = this.$store.state.states.getDataPageIds
      // const wpStr = this.isBigScreenPreview() ? "&w=" + websiteId + "&p=" + pageId : ""
      // // 先判断 getSwData(this.options）是否为空
      // const swData = getSwData(this.options)
      // let swUrl = ""
      // if (swData) {
      //   swUrl = "?sw=" + swData
      // }
      // const res = await this.asyncTask.add(this.instance.get(url + swUrl + wpStr))
      // const res = await this.asyncTask.add(this.instance.get(url + "?sw=" + getSwData(this.options) + wpStr))

      let paramsUrl = ""
      // 先判断 getSwData(this.options）是否为空
      const swData = getSwData(this.options) || this.getEventQuery()
      // if (swData) {
        paramsUrl = "?sw=" + swData
      // }
      // 判断是否是大屏预览
      if (this.isBigScreenPreview()) {
        if (paramsUrl) {
          paramsUrl += "&w=" + websiteId + "&p=" + pageId
        } else {
          paramsUrl = "?w=" + websiteId + "&p=" + pageId
        }
      }
      const res = await this.asyncTask.add(this.instance.get(url + paramsUrl))

      if (name && allChartDataHandle[name]) {
        allChartDataHandle[name].call(this, res)
      } else {
        allChartDataHandle.oldHandleChartData.call(
          this,
          this.options.chartOption,
          res,
          defaultGradientColor,
          defaultColor
        )
      }
    },
    getEventQuery() {
      let sw = ""
      if (window.chartEventBus) {
        const eventMap = window.chartEventBus.eventMap
        const idStr = `container_id_${this.myid.container_id}-rect_id_${this.myid.rect_id}`
        for (let i in eventMap) {
          if (eventMap[i].includes(idStr)) {
            const uid = getDocumentCookie("UID") || ""
            sw = window.xinanhangkongPlugin
              ? `${window.chartEventBus.dataMap[i] || ""}`
              : `${uid}%23%23%23${window.chartEventBus.dataMap[i] || ""}`
            break
          }
        }
      }
      return sw
    }
  }
}
